<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import * as XLSX from 'xlsx';

import Socket from "@/utils/Socket";
import NMPrintSocket from "@/utils/Print";
import { textPrintData } from "@/utils/printData/Text";
import { barcodePrintData } from "@/utils/printData/Barcode";
import { qrCodePrintData } from "@/utils/printData/QrCode";
import { linePrintData } from "@/utils/printData/Line";
import { graphPrintData } from "@/utils/printData/Graph";
import { imgPrintData } from "@/utils/printData/Img";
import { combinationPrintData } from "@/utils/printData/Combination";
import { batchPrintData } from "@/utils/printData/Batch";
import { toApiLanguage } from "@/utils/locale";
import { currencyUnitLabel } from "@/utils/currency";

/**
 * Starter page component
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Starter page",
      items: [
        {
          text: "Utility",
          href: "/",
        },
        {
          text: "Starter page",
          active: true,
        },
      ],
      userinfo: [],
      ismobile: false,
      orderpage: 1,
      orderarray: [],
      devicespage: 1,
      devicesearch: "",
      ordersearch: "",
      orderpaystatus: -1,
      orderpaytype: -1,
      ordertimes: [],
      allcount: 0,
      pickerOptions: {},
      datacount: 0,
      allpage: 0,
      activeapp: [],
      block: false,
      scopeRetryAttempt: 0,
      loading: true,
      empty: true,
      limit: 10,
      systemtype: 0,
      globalCurrey: "CNY",
      ordersettingdialog: false,
      ordersettingvalue: {},
      autorefreshdata: {
        status: false,
        task: "",
      },
      timer: 60,
      exceljson: [],
      // 标签打印机
      jsonObj: {
        printerImageProcessingInfo: {
          printQuantity: 1,
        },
      },
      // 打印服务实例（新增）
      socketData: null,
      // 打印监听（新增）
      unsubscribe: null,
      // 打印是否错误（新增）
      isPrintError: false,
      // 打印服务是否连接成功
      printSocketOpen: false,
      nMPrintSocket: null,
      usbPrinters: {},
      wifiPrinters: {},
      onlineUsbBool: false,
      onlineWifiBool: false,
      usbSelectPrinter: "",
      wifiSelectPrinter: "",
      initBool: false,
      density: 3,
      label_type: 1,
      print_mode: 1,
      auto_shut_down: 1,
      wifiName: "",
      wifiPassword: "",
      labelprinter: {
        loading: true,
        enable: false
      },
      dialogOrderV3QrForm: false,
      dialogOrderV3Setting: false,
      dialogOrderV3Manage: false,
      orderv3Creating: false,
      orderv3SettingSaving: false,
      orderv3QrListLoading: false,
      orderv3QrList: [],
      orderv3QrPage: 1,
      orderv3QrPageSize: 10,
      orderv3QrTotal: 0,
      devicelist: [],
      orderv3form: {
        time: [],
        price: 0,
        device: ["all"],
        one_time: true,
        max_volume: 0,
      },
      orderv3SettingForm: {
        order_id: 0,
        code: "",
        enable: 1,
        type: 1,
        max_volume: 0,
        used_volume: 0,
        time: [],
        reset_enable: true,
      },
      paymentTypes: [
        { value: -1, label: this.$t("device.orders.allstatus") },
        { value: 0, label: this.$t("device.orders.coinpay") },
        { value: 1, label: this.$t("device.orders.useramount") },
        { value: 2, label: this.$t("device.orders.alipay") },
        { value: 3, label: this.$t("device.orders.wxpay") },
        { value: 4, label: this.$t("device.orders.payment.applepay") },
        { value: 5, label: this.$t("device.orders.payment.googlewallet") },
        { value: 6, label: this.$t("device.orders.payment.amazonpay") },
        { value: 7, label: this.$t("device.orders.payment.qpay") },
        { value: 40, label: this.$t("device.orders.payment.bestpay") },
        { value: 41, label: this.$t("device.orders.payment.sandpay") },
        { value: 42, label: this.$t("device.orders.payment.paymentasia") },
        { value: 44, label: this.$t("device.orders.payment.cmb") },
        { value: 45, label: this.$t("device.orders.payment.icbc") },
        { value: 46, label: this.$t("device.orders.payment.allinpay") },
        { value: 55, label: this.$t("device.orders.payment.keruyun") },
        { value: 56, label: this.$t("device.orders.payment.youhao") },
        { value: 61, label: this.$t("device.orders.payment.nayax") },
        { value: 77, label: this.$t("device.orders.payment.coin") }
      ],
      selectedPaymentTypes: [-1],
      orderStatus: [
        { value: -1, label: this.$t("device.orders.allstatus") },
        { value: 0, label: this.$t("device.orders.nopay") },
        { value: 1, label: this.$t("device.orders.orderpay") },
        { value: 3, label: this.$t("device.orders.refuntrue") }
      ],
      selectedOrderStatus: -1,
    };
  },
  beforeDestroy() {
    if (this.socketData) {
      this.socketData.close(); // 假设你的 Socket 类有 close 方法
      this.socketData = null;
    }

    if (this.nMPrintSocket) {
      this.nMPrintSocket = null;
    }
  },

  mounted() {
    var that = this;
    that.title = that.$t("menuitems.devices.orders");
    that.items = [
      {
        text: that.$t("menuitems.devices.text"),
        href: "/",
      },
      {
        text: that.$t("menuitems.devices.orders"),
        active: true,
      },
    ];
    //   this.getdevicelist()
    that.userinfo = JSON.parse(localStorage.getItem("user"));
    {
      const rid = parseInt(
        that.userinfo.roleid != null
          ? that.userinfo.roleid
          : that.userinfo.roleId,
        10
      );
      if (Number.isFinite(rid) ? rid !== 0 : parseInt(that.userinfo.topuid, 10) >= 1) {
        that.block = true;
      }
    }
    let flag = navigator.userAgent.match(
      /(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      // that.ismobile = true;
    }
    let yy = new Date().getFullYear();
    let mm = new Date().getMonth();
    let dd = new Date().getDate();
    mm = mm + 1;
    const endDate = new Date(yy, mm - 1, dd);
    const startDate = new Date(yy, mm - 1, dd);
    startDate.setDate(startDate.getDate() - 1);
    const fmtOrderDate = (d) => d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate();
    that.ordertimes = [fmtOrderDate(startDate), fmtOrderDate(endDate)];
    that.pickerOptions = {
      shortcuts: [
        {
          text: that.$t("device.orders.oneday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: that.$t("device.orders.oneweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: that.$t("device.orders.onemonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: that.$t("device.orders.threemonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          },
        },
      ],
    };
    that.getorderlist();
    that.getsysteminfo();

    that.socketData = new Socket("ws://127.0.0.1:37989");

    that.socketData.open(
      (openBool) => {
        that.printSocketOpen = openBool;
        if (openBool) {
          // getLabelPrinterID 内部会先 getPrinters 再校验授权（精臣SDK要求顺序）
          that.getLabelPrinterID();
        }
      },
      (msg) => {
        console.log("msg", msg);
        if (msg.resultAck.callback != undefined) {
          const callbackName = msg.resultAck.callback.name;
          const msgInfo = msg.resultAck.info || {};
          const callbackData = msg.resultAck.callback;
          // 兼容 SDK：info 与 callback 中可能在不同字段
          if (callbackName == "onCoverStatusChange") {
            // 盒盖状态（精臣SDK）：0=上盖开启，1=上盖关闭
            const capStatus = msgInfo.capStatus ?? callbackData.coverStatus;
            console.log("盒盖状态", capStatus);
            if (capStatus == 0) {
              that.labelprinter.enable = false;
              that.$alert(that.$t("global.printer.label.capopen"), that.$t("global.alert.title"), {
                confirmButtonText: that.$t("global.button.ok")
              });
              that.$message.error(that.$t("global.printer.label.capopen"));
            } else if (capStatus == 1) {
              that.labelprinter.enable = true;
            }
          } else if (callbackName == "onElectricityChange") {
            // powerLever: 1-4，满格为4（精臣SDK）
            const power = msgInfo.power ?? callbackData.powerLever;
            console.log("电池电量等级", power);
          }
        }
      }
    );
    // 创建打印实例
    that.nMPrintSocket = new NMPrintSocket(that.socketData);

  },
  computed: {
    v3formtimeOption() {
      return {
        shortcuts: [{
          text: this.$t('orders.v3.hours1'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(end.getTime() + 3600 * 1000);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('orders.v3.hours3'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 3);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('orders.v3.hours5'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 5);
            picker.$emit('pick', [start, end]);
          }
        }]
      };
    },
    searchinorderlist() {
      var paycode = {
        wxpay: 3,
        alipay: 2,
      };
      var datas = this.orderarray.filter((value) => {
        return (
          !this.ordersearch ||
          value.ED_id.toLowerCase().includes(
            this.ordersearch.trim().toLowerCase()
          ) ||
          !this.ordersearch ||
          value.ED_name.toLowerCase().includes(
            this.ordersearch.trim().toLowerCase()
          ) ||
          !this.ordersearch ||
          value.sn.toLowerCase().includes(this.ordersearch.trim().toLowerCase())
        );
      });
      return datas;
    },
  },
  methods: {
    getsysteminfo() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "systeminfo",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          var d = response.data.data;
          that.systemtype = parseInt(d.model);
          if (d.currey) {
            that.globalCurrey = d.currey;
          }
        })
        .catch(function (error) {
          // // console.log(error);
        });
    },
    currencyLabel(code) {
      return currencyUnitLabel(this, code || this.globalCurrey);
    },
    getorderlist: function () {
      var that = this;
      that.orderarray = [];
      var date = that.ordertimes[0] + "," + that.ordertimes[1];
      that.orderlistloading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "orderlist",
            page: that.orderpage,
            date: date,
            limit: that.limit,
            paycode: that.selectedPaymentTypes,
            status: that.selectedOrderStatus,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          that.orderlistloading = false;
          var data = response.data;
          if (data.currey) {
            that.globalCurrey = data.currey;
          }
          if (data.count > 0) {
            that.orderarray = data.data;
            that.datacount = data.count;
            that.allpage = data.allpage;
            that.allcount = data.total;
          } else {
            that.warnIfEmptyDeviceScope(function () {
              that.getorderlist();
            });
          }
        })
        .catch(function (error) {
          that.orderlistloading = false;
          // // console.log(error);
        });
    },
    dropdown: function (command) {
      this.downloadexceljson(command);
    },
    downloadexceljson(type) {
      var that = this;
      var date = that.ordertimes[0] + "," + that.ordertimes[1];
      that.orderlistloading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "dump_orderlist_json",
            date: date,
            type: type,
            language: toApiLanguage(that.$i18n.locale),
            paycode: that.selectedPaymentTypes,
            status: that.selectedOrderStatus,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(async function (response) {
          var jsonData = response.data.table || [];
          const headers = [
            that.$t("orders.table.ordersn"),
            that.$t("orders.table.ED_id"),
            that.$t("orders.table.ED_name"),
            that.$t("orders.table.total"),
            that.$t("orders.table.value"),
            that.$t("orders.table.goodsname"),
            that.$t("orders.table.createtime"),
            that.$t("orders.table.paytime"),
            that.$t("orders.table.payway"),
            that.$t("orders.table.status"),
            that.$t("orders.table.delete"),
            that.$t("orders.table.user"),
            that.$t("orders.table.phone")
          ];
          const rows = jsonData.map(function (row) {
            return [
              row.sn,
              row.ED_id,
              row.ED_name,
              row.total,
              row.goodstotal,
              row.goodsname || row.title || "",
              row.addtime,
              row.paytime,
              row.payway,
              row.status,
              row.isdel,
              row.username,
              row.phone
            ];
          });
          const worksheet = XLSX.utils.aoa_to_sheet([headers].concat(rows));
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          const exportDate = new Date();
          const year = exportDate.getFullYear();
          const month = exportDate.getMonth() + 1;
          const day = exportDate.getDate();
          XLSX.writeFile(workbook, that.$t("menuitems.devices.orders") + `_${year}${month}${day}` + "_tableData.xlsx");
        })
        .catch(function (error) {
          // // console.log(error);
        })
        .finally(function () {
          that.orderlistloading = false;
        });
    },
    // downloadtable: function(){
    //   const workbook = XLSX.utils.book_new();
    //   const worksheet = XLSX.utils.json_to_sheet(this.orderarray);
    //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //   XLSX.writeFile(workbook, "order.xlsx");

    // },
    logdata: function (route, id) {
      var that = this;
      if (route == "order") {
        that.$toast.loading({
          message: that.$t("global.loading.readingv2"),
          forbidClick: true,
        });
        that.$axios
          .get("https://doc.aic.pet/" + id + ".orderlog")
          .then((response) => {
            that.$toast.clear();
            window.location.href = response.data.file;
          });
      }
    },
    handleSizeChange(val) {
      this.limit = val;
      this.getorderlist();
    },
    handleCurrentChange(val) {
      this.orderpage = val;
      this.getorderlist();
    },
    deletes(type, id) {
      var that = this;
      that
        .$confirm(
          that.$t("global.delete.deleteordertip"),
          that.$t("global.delete.sureyouaction"),
          {
            confirmButtonText: that.$t("global.button.ok"),
            cancelButtonText: that.$t("global.button.cancel"),
            type: "warning",
          }
        )
        .then(() => {
          that.$axios
            .post(
              that.apiuri,
              {
                action: "delete",
                type: type,
                id: id,
              },
              {
                headers: { Openid: that.userinfo.openid },
              }
            )
            .then(function (response) {
              if (response.data.status == 200) {
                that.$message({
                  message: that.$t("global.delete.success"),
                  type: "success",
                });
              } else if (response.data.status == 403) {
                that.$message({
                  message: that.$t("global.delete.auth"),
                  type: "warning",
                });
              } else {
                that.$message.error(that.$t("global.delete.500"));
              }
              that.getorderlist();
            })
            .catch(function (error) {
              // // console.log(error);
            });
        })
        .catch(() => { });
    },
    refund(orderid) {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "refunpay",
            orderid: orderid,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          if (response.data.status == 200) {
            that.$message({
              message: that.$t("global.success"),
              type: "success",
            });
          } else if (response.data.status == 202 || response.data.status == 508) {
            that.$message({
              message: that.$t(response.data.msg),
              type: "warning",
            });
          } else if (response.data.status == 403) {
            that.$message({
              message: that.$t("global.delete.auth"),
              type: "warning",
            });
          } else {
            that.$message.error(that.$t("global.delete.500"));
          }
          that.getorderlist();
        })
        .catch(function (error) {
          // // console.log(error);
        });

    },
    autorefresh(status) {
      if (status) {
        this.autorefreshdata.task = setInterval(() => {
          this.getorderlist();
        }, this.timer * 1000);
      } else {
        clearInterval(this.autorefreshdata.task);
      }
    },
    inputtocheckout() {
      var that = this;
      that
        .$prompt(
          that.$t("device.order.checkouttip"),
          that.$t("global.delete.sureyouaction"),
          {
            confirmButtonText: that.$t("global.button.ok"),
            cancelButtonText: that.$t("global.button.cancel"),
            type: "warning",
          }
        )
        .then(({ value }) => {
          that.$axios
            .post(
              that.apiuri,
              {
                action: "checkout",
                hex: value,
              },
              {
                headers: { Openid: that.userinfo.openid },
              }
            )
            .then(function (response) {
              that.getorderlist();
              if (response.data.status == 200) {
                that.$message({
                  message: that.$t("global.success"),
                  type: "success",
                });
              } else if (response.data.status == 403) {
                that.$message({
                  message: that.$t("global.delete.auth"),
                  type: "warning",
                });
              } else {
                that.$message.error(that.$t("global.delete.500"));
              }
            })
            .catch(function (error) {
              // // console.log(error);
            });
        })
        .catch(() => { });
    },
    // 获取授权打印机ID，需先 getPrinters 获取列表后再校验
    async getLabelPrinterID() {
      const that = this;
      if (!that.printSocketOpen) return;
      try {
        // 先获取打印机列表
        await that.getPrinters();
        // 再获取后端授权的打印机ID
        const response = await that.$axios.post(
          that.apiuri,
          { action: "getlabelprinter" },
          { headers: { Openid: that.userinfo.openid } }
        );
        if (response.data.status == 200) {
          const authorizedPrinter = response.data.data;
          if (authorizedPrinter && that.usbPrinters[authorizedPrinter] != null) {
            that.usbSelectPrinter = authorizedPrinter;
            await that.selectOnLineUsbPrinter();
          } else {
            that.$message({
              message: that.$t("global.printer.label.authorize"),
              type: "warning",
            });
          }
        }
      } catch (error) {
        // console.log(error);
      }
    },
    async getPrinters() {
      console.log("getPrinters");
      console.log("this.printSocketOpen", this.printSocketOpen);
      if (!this.printSocketOpen) {
        this.$message({
          message: this.$t("global.printer.label.initfailed1"),
          type: "warning",
        });
        return;
      }
      try {
        const allPrintersRes = await this.nMPrintSocket.getAllPrinters();
        // console.log(allPrintersRes, "allPrintersRes");
        if (allPrintersRes.resultAck.errorCode === 0) {
          const allPrinters = JSON.parse(allPrintersRes.resultAck.info);
          this.usbPrinters = { ...allPrinters };
          this.usbSelectPrinter = Object.keys(this.usbPrinters)[0];
          // console.log(this.usbSelectPrinter)
          this.labelprinter.loading = false


        } else {
          // alert("没有在线的打印机");
          this.$message({
            message: this.$t("global.printer.label.notfound"),
            type: "warning",
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async selectOnLineUsbPrinter() {
      if (!this.printSocketOpen) {
        this.$message({
          message: this.$t("global.printer.label.initfailed1"),
          type: "warning",
        });
        return;
      }
      try {
        const res = await this.nMPrintSocket.selectPrinter(
          this.usbSelectPrinter,
          parseInt(this.usbPrinters[this.usbSelectPrinter])
        );
        console.log("选择打印机", res);

        if (res.resultAck.errorCode === 0) {
          console.log("连接成功");
          this.onlineUsbBool = true;
          this.init()
        } else {
          console.log("连接失败");
          this.onlineUsbBool = false;
          alert("连接失败");
        }
      } catch (err) {
        console.error(err);
      }
    },
    //初始化SDK
    async init() {
      if (!this.printSocketOpen) {
        this.$message({
          message: this.$t("global.printer.label.initfailed1"),
          type: "warning",
        });
        return;
      }
      //初始化数据
      try {
        const res = await this.nMPrintSocket.initSdk({ fontDir: "" });
        if (res.resultAck.errorCode == 0) {
          console.log("初始化成功");
          this.initBool = true;
          this.labelprinter.enable = true;
        } else {
          console.log("初始化失败");
          this.initBool = false;
          this.labelprinter.enable = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async startPrintJobTest(content) {
      if (!this.printSocketOpen) {
        this.$message({
          message: this.$t("global.printer.label.initfailed1"),
          type: "warning",
        });
        return;
      }
      const contentArr = Array.isArray(content) ? content : [content];
      this.batchPrintJob(contentArr);
    },
    //批量打印列表数据
    async batchPrintJob(list) {
      const printQuantity =
        this.jsonObj.printerImageProcessingInfo.printQuantity;
      this.isPrintError = false;

      let printListener = null;
      const cleanupListener = () => {
        if (printListener) {
          console.log(
            "Listeners before cleanup:",
            this.socketData.getListenersCount()
          );
          this.socketData.removePrintListener(printListener);
          console.log(
            "Listeners after cleanup:",
            this.socketData.getListenersCount()
          );
          printListener = null;
        }
      };

      try {
        cleanupListener(); // 清理可能存在的旧监听器
        // console.log("Adding new listener...");
        printListener = this.socketData.addPrintListener(async (msg) => {

          const resultAck = msg?.resultAck;
          console.log(resultAck)
          if (resultAck?.printQuantity != null && resultAck?.onPrintPageCompleted != null) {
            console.log('打印进度更新', {
              当前进度: "第" + resultAck.printQuantity + "页," + "第" + resultAck.onPrintPageCompleted + "份",
              总页数: list.length,
              完成长度: resultAck.onPrintPageLengthCompleted
            });
          }

          // console.log("Received print message:", msg);

          // 打印完成
          if (
            msg.resultAck.onPrintPageCompleted === printQuantity &&
            msg.resultAck.printQuantity === list.length
          ) {
            const endRes = await this.nMPrintSocket.endJob();
            if (endRes.resultAck.errorCode === 0) {
              console.log("打印完成");
            }
            cleanupListener();
            return;
          }

          // 处理错误
          if (msg.resultAck.errorCode !== 0) {
            this.isPrintError = true;
            cleanupListener();
            console.log("打印错误全局111:" + msg.resultAck.info);
          }
        });


        const startRes = await this.nMPrintSocket.startJob(
          3,
          1,
          1,
          list.length * printQuantity
        );

        if (startRes.resultAck.errorCode == 0) {
          await this.printTag(list, 0);
        } else {
          cleanupListener();
        }
      } catch (err) {
        console.error(err);
        cleanupListener();
      }
    },
    // 绘制打印标签
    async printTag(list, x) {
      // console.log(list, x);
      //设置画布尺寸
      try {
        const res = await this.nMPrintSocket.InitDrawingBoard(
          list[x].InitDrawingBoardParam
        );
        if (res.resultAck.errorCode != 0) {
          return;
        }
        // 提交打印任务
        this.printItem(list, x, list[x].elements, 0);
      } catch (err) {
        console.error(err);
      }
    },
    async printItem(list, x, item, i) {
      try {
        if (i < item.length) {
          let arrParse;
          switch (item[i].type) {
            case "text":
              //绘制文本
              arrParse = await this.nMPrintSocket.DrawLableText(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "qrCode":
              arrParse = await this.nMPrintSocket.DrawLableQrCode(item[i].json);
              //绘制二维码
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "barCode":
              //绘制一维码
              arrParse = await this.nMPrintSocket.DrawLableBarCode(
                item[i].json
              );
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "line":
              //绘制线条
              arrParse = await this.nMPrintSocket.DrawLableLine(item[i].json);
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "graph":
              //绘制边框
              arrParse = await this.nMPrintSocket.DrawLableGraph(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }

              i++;
              await this.printItem(list, x, item, i);
              break;
            case "image":
              //绘制边框
              arrParse = await this.nMPrintSocket.DrawLableImage(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
          }
        } else {
          //遍历完成，开始打印
          await this.nMPrintSocket.commitJob(
            null,
            JSON.stringify(this.jsonObj)
          );

          if (this.isPrintError) {
            return;
          }
          if (x < list.length - 1) {
            x++;
            await this.printTag(list, x);
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    handlePaymentTypeChange(value) {
      // 如果选择了-1(全部状态)，清除其他选项
      if (value.includes(-1)) {
        this.selectedPaymentTypes = [-1];
      }
      // 如果选择了其他选项，移除-1
      else if (this.selectedPaymentTypes.includes(-1) && value.length > 0) {
        this.selectedPaymentTypes = value.filter(item => item !== -1);
      }
    },
    createOrderV3() {
      var that = this;
      if (that.orderv3Creating) {
        return;
      }
      if (!that.orderv3form.time || that.orderv3form.time.length !== 2) {
        that.$message.warning(that.$t("orders.v3.timeRequired"));
        return;
      }
      if (!that.orderv3form.device || that.orderv3form.device.length === 0) {
        that.$message.warning(that.$t("orders.v3.deviceRequired"));
        return;
      }
      that.orderv3Creating = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "createorderv3",
            time: that.orderv3form.time,
            price: that.orderv3form.price,
            currency: that.globalCurrey,
            device: that.orderv3form.device,
            one_time: that.orderv3form.one_time ? 1 : 0,
            max_volume: parseInt(that.orderv3form.max_volume, 10) || 0,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.getorderlist();
          if (response.data.status == 200) {
            that.dialogOrderV3QrForm = false;
            if (response.data.template) {
              that.startPrintJobTest(response.data.template);
            }
          } else if (response.data.message) {
            that.$message.error(response.data.message);
          }
        })
        .catch(function () {
          that.$message.error(that.$t("global.errors.network"));
        })
        .finally(function () {
          that.orderv3Creating = false;
        });
    },
    openOrderV3Dialog() {
      this.orderv3form = {
        time: [],
        price: 0,
        device: ["all"],
        one_time: true,
        max_volume: 0,
      };
      this.dialogOrderV3QrForm = true;
      if (!this.devicelist.length) {
        this.getdevicelist();
      }
    },
    openOrderV3Manage() {
      this.orderv3QrPage = 1;
      this.dialogOrderV3Manage = true;
      this.loadOrderv3QrList();
    },
    loadOrderv3QrList() {
      const that = this;
      that.orderv3QrListLoading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "list_orderv3_qr",
            page: that.orderv3QrPage,
            limit: that.orderv3QrPageSize,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.orderv3QrListLoading = false;
          if (response.data.status === 200) {
            that.orderv3QrList = response.data.data || [];
            that.orderv3QrTotal = response.data.total || 0;
            if (response.data.page) {
              that.orderv3QrPage = response.data.page;
            }
          } else {
            that.orderv3QrList = [];
            that.orderv3QrTotal = 0;
          }
        })
        .catch(function () {
          that.orderv3QrListLoading = false;
          that.orderv3QrList = [];
          that.orderv3QrTotal = 0;
        });
    },
    handleOrderv3QrPageChange(page) {
      this.orderv3QrPage = page;
      this.loadOrderv3QrList();
    },
    handleOrderv3QrSizeChange(size) {
      this.orderv3QrPageSize = size;
      this.orderv3QrPage = 1;
      this.loadOrderv3QrList();
    },
    getdevicelist() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getdevicelist",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.devicelist = response.data.data || [];
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleOrderv3DeviceChange(selected) {
      if (selected.includes("all")) {
        this.orderv3form.device = ["all"];
        return;
      }
      const deviceIds = this.devicelist.map((device) => device.ED_id);
      const allSelected = deviceIds.length > 0 && deviceIds.every((id) => selected.includes(id));
      if (allSelected) {
        this.orderv3form.device = ["all"];
      }
    },
    openOrderv3Settings(row) {
      if (!row) {
        return;
      }
      const qr = row.orderv3_qr || row;
      const orderId = row.id || qr.order_id;
      if (!orderId) {
        return;
      }
      this.orderv3SettingForm = {
        order_id: orderId,
        code: qr.code || "",
        enable: qr.enable,
        type: qr.type || 1,
        max_volume: qr.max_volume || 0,
        used_volume: qr.used_volume || 0,
        time: [
          new Date(qr.begin_time * 1000),
          new Date(qr.end_time * 1000),
        ],
        reset_enable: true,
      };
      this.dialogOrderV3Setting = true;
    },
    resetOrderv3Qr() {
      const that = this;
      if (!that.orderv3SettingForm.time || that.orderv3SettingForm.time.length !== 2) {
        that.$message.warning(that.$t("orders.v3.timeRequired"));
        return;
      }
      that.orderv3SettingSaving = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "reset_orderv3_qr",
            order_id: that.orderv3SettingForm.order_id,
            time: that.orderv3SettingForm.time,
            reset_enable: that.orderv3SettingForm.reset_enable ? 1 : 0,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.orderv3SettingSaving = false;
          if (response.data.status === 200) {
            that.$message.success(that.$t("orders.v3.resetSuccess"));
            that.dialogOrderV3Setting = false;
            const target = that.orderarray.find((item) => item.id === that.orderv3SettingForm.order_id);
            if (target && target.orderv3_qr && response.data.orderv3_qr) {
              target.orderv3_qr.begin_time = response.data.orderv3_qr.begin_time;
              target.orderv3_qr.end_time = response.data.orderv3_qr.end_time;
              target.orderv3_qr.enable = response.data.orderv3_qr.enable;
              if (response.data.orderv3_qr.type) {
                target.orderv3_qr.type = response.data.orderv3_qr.type;
              }
            } else {
              that.getorderlist();
            }
            that.loadOrderv3QrList();
          } else if (response.data.message) {
            that.$message.error(response.data.message);
          } else {
            that.$message.error(that.$t("global.error"));
          }
        })
        .catch(function () {
          that.orderv3SettingSaving = false;
          that.$message.error(that.$t("global.errors.network"));
        });
    },
    orderv3QrStatusText(qr) {
      if (!qr) {
        return "-";
      }
      const enable = parseInt(qr.enable, 10);
      const type = parseInt(qr.type, 10) || 1;
      if (enable === 0) {
        return this.$t("orders.v3.qrStatusUsed");
      }
      if (type === 2 || enable === 2) {
        return this.$t("orders.v3.qrStatusReusable");
      }
      return this.$t("orders.v3.qrStatusUnused");
    },
    formatOrderv3TimeRange(beginTime, endTime) {
      if (!beginTime || !endTime) {
        return "-";
      }
      const begin = this.$options.filters.formatTimer(beginTime);
      const end = this.$options.filters.formatTimer(endTime);
      return `${begin} ${this.$t("orders.v3.rangeSeparator")} ${end}`;
    },
    formatOrderv3VolumeLimit(row) {
      const maxVolume = parseInt(row && row.max_volume, 10) || 0;
      if (maxVolume <= 0) {
        return this.$t("orders.v3.volumeUnlimited");
      }
      const usedVolume = parseInt(row && row.used_volume, 10) || 0;
      return `${maxVolume} ml (${this.$t("orders.v3.volumeUsed")}: ${usedVolume} ml)`;
    },
  },
  filters: {
    formatTimer: function (value) {
      value = value * 1000;
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card" v-loading="loading">
          <div class="card-body">
            <!-- 响应式筛选区域 -->
            <div class="row mb-3">
              <!-- 日期选择器 - 大屏幕占4列，小屏幕占12列 -->
              <div class="col-lg-4 col-md-6 col-12 mb-3">
                <label class="form-label">{{ $t("device.orders.ordertime") }}</label>
                <el-date-picker v-model="ordertimes" type="daterange" align="right" unlink-panels format="yyyy/MM/dd"
                  value-format="yyyy/MM/dd" :range-separator="$t('device.orders.to')"
                  :start-placeholder="$t('device.orders.begindate')" :end-placeholder="$t('device.orders.enddate')"
                  :picker-options="pickerOptions" style="width: 100%">
                </el-date-picker>
              </div>

              <!-- 订单状态 - 大屏幕占2列，中屏幕占3列，小屏幕占6列 -->
              <div class="col-lg-2 col-md-3 col-6 mb-3">
                <label class="form-label">{{ $t("device.orders.orderstatus") }}</label>
                <el-select v-model="selectedOrderStatus" placeholder="请选择" style="width: 100%">
                  <el-option v-for="item in orderStatus" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>

              <!-- 支付类型 - 大屏幕占2列，中屏幕占3列，小屏幕占6列 -->
              <div class="col-lg-2 col-md-3 col-6 mb-3">
                <label class="form-label">{{ $t("device.orders.paytype") }}</label>
                <el-select v-model="selectedPaymentTypes" multiple placeholder="请选择" style="width: 100%"
                  @change="handlePaymentTypeChange">
                  <el-option v-for="item in paymentTypes" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>

              <!-- 操作按钮 - 大屏幕占3列，中屏幕占6列，小屏幕占12列 -->
              <div class="col-lg-3 col-md-6 col-12 mb-3">
                <label class="form-label">{{ $t("device.orders.action") }}</label>
                <div class="d-flex flex-wrap gap-2">
                  <el-button type="primary" @click="getorderlist()" icon="el-icon-search" size="small">
                    {{ $t("device.lists.search") }}
                  </el-button>
                  <el-dropdown split-button @command="dropdown" @click="downloadexceljson(0)" trigger="click"
                    size="small">
                    {{ $t("device.lists.excel") }}
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="1">{{ $t("device.lists.excelreg") }}</el-dropdown-item>
                      <el-dropdown-item command="2">{{ $t("device.lists.excelnonereg") }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>

              <!-- 自动刷新 - 大屏幕占1列，中屏幕占3列，小屏幕占6列 -->
              <div class="col-lg-1 col-md-3 col-6 mb-3">
                <label class="form-label">{{ $t("device.orders.autorefresh") }}</label>
                <div class="d-flex justify-content-center">
                  <el-switch v-model="autorefreshdata.status" :inactive-text="$t('global.close')"
                    :active-text="$t('global.open')" @change="autorefresh" />
                </div>
              </div>
            </div>

            <!-- 搜索框和额外操作 -->
            <div class="row mb-3">
              <!-- 关键词搜索 - 占8列 -->
              <div class="col-lg-8 col-md-8 col-12 mb-3">
                <label class="form-label">{{ $t("device.orders.keyword") }}</label>
                <el-input v-model="ordersearch" :placeholder="$t('device.orders.searchorder')"
                  prefix-icon="el-icon-search" clearable>
                </el-input>
              </div>

              <!-- 额外操作按钮 - 占4列 -->
              <div class="col-lg-4 col-md-4 col-12 mb-3">
                <label class="form-label">&nbsp;</label>
                <div class="d-flex justify-content-end gap-2 flex-wrap">
                  <el-button type="default" @click="openOrderV3Manage" size="small">
                    {{ $t('orders.v3.manage') }}
                  </el-button>
                  <el-button type="primary" @click="openOrderV3Dialog" v-if="labelprinter.enable" size="small">
                    {{ $t('orders.v3.create') }}
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <!-- 响应式表格区域 -->
          <div class="card-body">
            <!-- 桌面端表格 -->
            <div class="d-none d-lg-block">
              <div style="overflow-x: auto;">
                <table id="deviceslist_table" class="table table-striped table-hover">
                  <thead class="table-dark">
                    <tr>
                      <th class="sortStyle">{{ $t("device.orders.orderid") }}</th>
                      <th class="sortStyle" v-if="systemtype == 0">{{ $t("device.orders.goodsname") }}</th>
                      <th class="sortStyle">{{ $t("device.orders.salsevalues") }}</th>
                      <th class="sortStyle">{{ $t("device.orders.orderprice") }}</th>
                      <th class="sortStyle" v-if="systemtype == 0">{{ $t("device.orders.paytype") }}</th>
                      <th class="sortStyle" v-if="systemtype != 1">{{ $t("device.orders.orderstatus") }}</th>
                      <th class="sortStyle" v-if="systemtype == 2">{{ $t("device.orders.user") }}</th>
                      <th class="sortStyle">{{ $t("device.orders.ordertime") }}</th>
                      <th class="sortStyle">{{ $t("device.orders.deviceid") }}</th>
                      <th class="sortStyle">{{ $t("device.orders.action") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!searchinorderlist || orderarray.length == 0">
                      <td colspan="10">
                        <el-empty :description="$t('device.orders.nodata')"></el-empty>
                      </td>
                    </tr>
                    <tr v-for="(val, idx) in searchinorderlist" :class="'device' + val.id" :key="val.id">
                      <td>
                        <span :id="val.sn">{{ val.shid }}</span>
                        <b-tooltip :target="val.sn">{{ val.sn }}</b-tooltip>
                        <span class="badge badge-info ms-1" v-if="val.orderv3_qr">{{ $t("orders.v3.qrBadge") }}</span>
                      </td>
                      <td v-if="systemtype == 0 && val.goods">{{ val.goods }}</td>
                      <td v-if="systemtype == 0 && !val.goods">{{ $t("device.orders.nogoodsname") }}</td>
                      <td>
                        {{ val.goodstotal }}
                        <span v-if="val.ED_id.substring(0, 4) == 7710">{{ $t("device.orders.pack") }}</span>
                        <span v-else>ML</span>
                      </td>
                      <td>
                        {{ val.total }} {{ currencyLabel() }}
                        <span v-if="val.refun_fee > 0 && val.status == 3">({{ $t("device.orders.status.refund_price")
                          }}:{{ val.refun_fee }} {{ currencyLabel() }})</span>
                        <span v-if="val.refun_fee > 0 && val.status == 1">({{ $t("device.orders.status.discount_price")
                          }}:{{ val.refun_fee }} {{ currencyLabel() }})</span>
                      </td>
                      <td v-if="systemtype == 0">
                        <span v-if="val.payway == 0"><i class="ri-wallet-line"></i>{{ $t("device.orders.payment.cash")
                          }}</span>
                        <span v-if="val.payway == 1"><i class="ri-wallet-line"></i>{{ $t("device.orders.payment.wallet")
                          }}</span>
                        <span v-if="val.payway == 2"><i class="fab fa-alipay" style="color: #4dabf7"></i>{{
                          $t("device.orders.payment.alipay") }}</span>
                        <span v-if="val.payway == 3"><i class="fab fa-weixin" style="color: #3cb034"></i>{{
                          $t("device.orders.payment.wxpay") }}</span>
                        <span v-if="val.payway == 4"><i class="fab fa-apple-pay"></i>{{
                          $t("device.orders.payment.applepay") }}</span>
                        <span v-if="val.payway == 5"><i class="fab fa-google-wallet"></i>{{
                          $t("device.orders.payment.googlewallet") }}</span>
                        <span v-if="val.payway == 6"><i class="fab fa-amazon-pay"></i>{{
                          $t("device.orders.payment.amazonpay") }}</span>
                        <span v-if="val.payway == 7"><i class="fab fa-qq"></i>{{ $t("device.orders.payment.qpay")
                          }}</span>
                        <span v-if="val.payway == 40"><i class="fab fa-bestpay"></i>{{
                          $t("device.orders.payment.bestpay") }}</span>
                        <span v-if="val.payway == 41"><i class="fab fa-sandpay"></i>{{
                          $t("device.orders.payment.sandpay") }}</span>
                        <span v-if="val.payway == 61"><i class="fab fa-nyax"></i>{{ $t("device.orders.payment.nayax")
                          }}</span>
                      </td>
                      <td v-if="systemtype != 1">
                        <label class="badge badge-secondary" v-if="val.paytime > 0 && val.refun_fee == 0">{{
                          $t("device.orders.status.orderpay") }}</label>
                        <label class="badge badge-danger" v-if="val.paytime == 0">{{ $t("device.orders.status.nopay")
                          }}</label>
                        <label class="badge badge-danger" v-if="val.feedback == 6 && systemtype != 2">{{
                          $t("device.orders.status.devicedown") }}</label>
                        <label class="badge badge-danger" v-if="val.feedback == 2 && systemtype != 2">{{
                          $t("device.orders.status.returnfalse") }}</label>
                        <label class="badge badge-info" v-if="val.feedback == 3">{{
                          $t("device.orders.status.beersurpgoods") }}</label>
                        <label class="badge badge-warning"
                          v-if="val.feedback == 7 && val.paytime > 0 && val.refun_fee == 0 && systemtype != 2">{{
                            $t("device.orders.status.serversenddone") }}</label>
                        <label class="badge badge-success"
                          v-if="val.feedback == 1 && val.paytime > 0 && val.refun_fee == 0 && systemtype != 2">{{
                            $t("device.orders.status.pushdone") }}</label>
                        <label class="badge badge-success"
                          v-if="val.feedback == 3 && val.paytime > 0 && val.refun_fee == 0 && val.ED_id == 750004340001">{{
                            $t("device.orders.status.pushdone") }}</label>
                        <label class="badge badge-success"
                          v-if="val.feedback == 10 && val.paytime > 0 && val.refun_fee == 0">{{
                            $t("device.orders.status.dropbag_error") }}</label>
                        <label class="badge badge-success"
                          v-if="val.feedback == 11 && val.paytime > 0 && val.refun_fee == 0">{{
                            $t("device.orders.status.getcup_error") }}</label>
                        <label class="badge badge-success"
                          v-if="val.feedback == 12 && val.paytime > 0 && val.refun_fee == 0">{{
                            $t("device.orders.status.flow_error") }}</label>
                        <label class="badge badge-warning" v-if="val.refun_fee > 0 && val.status == 3">{{
                          $t("device.orders.status.refuntrue") }}</label>
                        <label class="badge badge-warning" v-if="val.refun_fee > 0 && val.status == 1">{{
                          $t("device.orders.status.orderpay") }}</label>
                      </td>
                      <td v-if="systemtype == 2">
                        <span v-if="val.uid > 0 && val.user">{{ val.user }}</span>
                        <span v-else-if="val.uid > 0 && !val.user">{{ $t("device.order.usernotfound") }}</span>
                        <span v-else>
                          <span v-if="val.user">{{ $t("device.order.grouppay", { group: val.user }) }}</span>
                          <span v-else>
                            <span v-if="val.payway == 0"><i class="ri-wallet-line"></i>{{
                              $t("device.orders.payment.cash") }}</span>
                            <span v-if="val.payway == 1"><i class="ri-wallet-line"></i>{{
                              $t("device.orders.payment.wallet") }}</span>
                            <span v-if="val.payway == 2"><i class="fab fa-alipay" style="color: #4dabf7"></i>{{
                              $t("device.orders.payment.alipay") }}</span>
                            <span v-if="val.payway == 3"><i class="fab fa-weixin" style="color: #3cb034"></i>{{
                              $t("device.orders.payment.wxpay") }}</span>
                            <span v-if="val.payway == 4"><i class="fab fa-apple-pay"></i>{{
                              $t("device.orders.payment.applepay") }}</span>
                            <span v-if="val.payway == 5"><i class="fab fa-google-wallet"></i>{{
                              $t("device.orders.payment.googlewallet") }}</span>
                            <span v-if="val.payway == 6"><i class="fab fa-amazon-pay"></i>{{
                              $t("device.orders.payment.amazonpay") }}</span>
                            <span v-if="val.payway == 7"><i class="fab fa-qq"></i>{{ $t("device.orders.payment.qpay")
                              }}</span>
                            <span v-if="val.payway == 40"><i class="fab fa-bestpay"></i>{{
                              $t("device.orders.payment.bestpay") }}</span>
                            <span v-if="val.payway == 41"><i class="fab fa-sandpay"></i>{{
                              $t("device.orders.payment.sandpay") }}</span>
                            <span v-if="val.payway == 42">{{ $t("device.orders.payment.paymentasia") }}</span>
                            <span v-if="val.payway == 44">{{ $t("device.orders.payment.cmb") }}</span>
                            <span v-if="val.payway == 45">{{ $t("device.orders.payment.icbc") }}</span>
                            <span v-if="val.payway == 46">{{ $t("device.orders.payment.allinpay") }}</span>
                            <span v-if="val.payway == 55">{{ $t("device.orders.payment.keruyun") }}</span>
                            <span v-if="val.payway == 56">{{ $t("device.orders.payment.youhao") }}</span>
                            <span v-if="val.payway == 61"><i class="fab fa-nyax"></i>{{
                              $t("device.orders.payment.nayax") }}</span>
                            <span v-if="val.payway == 77">{{ $t("device.orders.payment.coin") }}</span>
                          </span>
                        </span>
                      </td>
                      <td>
                        <span v-if="val.paytime > 0">{{ val.paytime | formatTimer }}</span>
                        <span v-if="val.paytime == 0">{{ val.addtime | formatTimer }}</span>
                      </td>
                      <td>
                        <span :id="'orderid' + idx">{{ val.ED_id }}</span>
                        <b-tooltip :target="'orderid' + idx">{{ val.ED_name }}</b-tooltip>
                      </td>
                      <td>
                        <div class="btn-group" role="group">
                          <router-link :to="{ path: '/device/orderdetail', query: { id: val.id } }">
                            <button class="btn btn-info btn-sm">{{ $t("device.orders.button.info") }}</button>
                          </router-link>
                          <button class="btn btn-dark btn-sm" @click="deletes('order', val.id)"
                            v-if="!block && (val.payway == 1 || val.payway == 3 || val.payway == 2 || val.payway == 45 || val.payway == 46)">{{
                              $t("device.orders.button.delete") }}</button>
                          <button class="btn btn-warning btn-sm" @click="refund(val.id)"
                            v-if="val.refund_button == 1">{{ $t("device.orders.button.refund") }}</button>
                          <button class="btn btn-secondary btn-sm" @click="openOrderv3Settings(val)"
                            v-if="val.orderv3_qr">{{ $t("orders.v3.settings") }}</button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- 移动端卡片布局 -->
            <div class="d-lg-none">
              <div v-if="!searchinorderlist || orderarray.length == 0" class="text-center py-4">
                <el-empty :description="$t('device.orders.nodata')"></el-empty>
              </div>
              <div v-for="val in searchinorderlist" :key="val.id" class="card mb-3">
                <div class="card-body">
                  <div class="row">
                    <div class="col-6">
                      <h6 class="card-title">{{ $t("device.orders.orderid") }}: {{ val.shid }}</h6>
                    </div>
                    <div class="col-6 text-end">
                      <span class="badge">{{ val.ED_id }}</span>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <div class="col-12">
                      <small class="text-muted">{{ $t("device.orders.goodsname") }}:</small>
                      <span v-if="val.goods">{{ val.goods }}</span>
                      <span v-else>{{ $t("device.orders.nogoodsname") }}</span>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <div class="col-6">
                      <small class="text-muted">{{ $t("device.orders.salsevalues") }}:</small>
                      <div>{{ val.goodstotal }} <span v-if="val.ED_id.substring(0, 4) == 7710">{{
                        $t("device.orders.pack") }}</span><span v-else>ML</span></div>
                    </div>
                    <div class="col-6">
                      <small class="text-muted">{{ $t("device.orders.orderprice") }}:</small>
                      <div>{{ val.total }} {{ currencyLabel() }}</div>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <div class="col-12">
                      <small class="text-muted">{{ $t("device.orders.paytype") }}:</small>
                      <div>
                        <span v-if="val.payway == 0"><i class="ri-wallet-line"></i> {{ $t("device.orders.payment.cash")
                          }}</span>
                        <span v-if="val.payway == 1"><i class="ri-wallet-line"></i> {{
                          $t("device.orders.payment.wallet") }}</span>
                        <span v-if="val.payway == 2"><i class="fab fa-alipay" style="color: #4dabf7"></i> {{
                          $t("device.orders.payment.alipay") }}</span>
                        <span v-if="val.payway == 3"><i class="fab fa-weixin" style="color: #3cb034"></i> {{
                          $t("device.orders.payment.wxpay") }}</span>
                        <span v-if="val.payway == 4"><i class="fab fa-apple-pay"></i> {{
                          $t("device.orders.payment.applepay") }}</span>
                        <span v-if="val.payway == 5"><i class="fab fa-google-wallet"></i> {{
                          $t("device.orders.payment.googlewallet") }}</span>
                        <span v-if="val.payway == 6"><i class="fab fa-amazon-pay"></i> {{
                          $t("device.orders.payment.amazonpay") }}</span>
                        <span v-if="val.payway == 7"><i class="fab fa-qq"></i> {{ $t("device.orders.payment.qpay")
                          }}</span>
                        <span v-if="val.payway == 40"><i class="fab fa-bestpay"></i> {{
                          $t("device.orders.payment.bestpay") }}</span>
                        <span v-if="val.payway == 41"><i class="fab fa-sandpay"></i> {{
                          $t("device.orders.payment.sandpay") }}</span>
                        <span v-if="val.payway == 42">{{ $t("device.orders.payment.paymentasia") }}</span>
                        <span v-if="val.payway == 44">{{ $t("device.orders.payment.cmb") }}</span>
                        <span v-if="val.payway == 45">{{ $t("device.orders.payment.icbc") }}</span>
                        <span v-if="val.payway == 46">{{ $t("device.orders.payment.allinpay") }}</span>
                        <span v-if="val.payway == 55">{{ $t("device.orders.payment.keruyun") }}</span>
                        <span v-if="val.payway == 61"><i class="fab fa-nyax"></i> {{ $t("device.orders.payment.nayax")
                          }}</span>
                        <span v-if="val.payway == 77">{{ $t("device.orders.payment.coin") }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-2" v-if="systemtype != 1">
                    <div class="col-12">
                      <small class="text-muted">{{ $t("device.orders.orderstatus") }}:</small>
                      <div>
                        <label class="badge badge-secondary" v-if="val.paytime > 0 && val.refun_fee == 0">{{
                          $t("device.orders.status.orderpay") }}</label>
                        <label class="badge badge-danger" v-if="val.paytime == 0">{{ $t("device.orders.status.nopay")
                          }}</label>
                        <label class="badge badge-danger" v-if="val.feedback == 6 && systemtype != 2">{{
                          $t("device.orders.status.devicedown") }}</label>
                        <label class="badge badge-danger" v-if="val.feedback == 2 && systemtype != 2">{{
                          $t("device.orders.status.returnfalse") }}</label>
                        <label class="badge badge-info" v-if="val.feedback == 3">{{
                          $t("device.orders.status.beersurpgoods") }}</label>
                        <label class="badge badge-warning"
                          v-if="val.feedback == 7 && val.paytime > 0 && val.refun_fee == 0 && systemtype != 2">{{
                            $t("device.orders.status.serversenddone") }}</label>
                        <label class="badge badge-success"
                          v-if="val.feedback == 1 && val.paytime > 0 && val.refun_fee == 0 && systemtype != 2">{{
                            $t("device.orders.status.pushdone") }}</label>
                        <label class="badge badge-success"
                          v-if="val.feedback == 3 && val.paytime > 0 && val.refun_fee == 0 && val.ED_id == 750004340001">{{
                            $t("device.orders.status.pushdone") }}</label>
                        <label class="badge badge-success"
                          v-if="val.feedback == 10 && val.paytime > 0 && val.refun_fee == 0">{{
                            $t("device.orders.status.dropbag_error") }}</label>
                        <label class="badge badge-success"
                          v-if="val.feedback == 11 && val.paytime > 0 && val.refun_fee == 0">{{
                            $t("device.orders.status.getcup_error") }}</label>
                        <label class="badge badge-success"
                          v-if="val.feedback == 12 && val.paytime > 0 && val.refun_fee == 0">{{
                            $t("device.orders.status.flow_error") }}</label>
                        <label class="badge badge-warning" v-if="val.refun_fee > 0 && val.status == 3">{{
                          $t("device.orders.status.refuntrue") }}</label>
                        <label class="badge badge-warning" v-if="val.refun_fee > 0 && val.status == 1">{{
                          $t("device.orders.status.orderpay") }}</label>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <div class="col-12">
                      <small class="text-muted">{{ $t("device.orders.ordertime") }}:</small>
                      <div>
                        <span v-if="val.paytime > 0">{{ val.paytime | formatTimer }}</span>
                        <span v-if="val.paytime == 0">{{ val.addtime | formatTimer }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-12">
                      <div class="btn-group w-100" role="group">
                        <router-link :to="{ path: '/device/orderdetail', query: { id: val.id } }"
                          class="btn btn-info btn-sm flex-fill">
                          {{ $t("device.orders.button.info") }}
                        </router-link>
                        <button class="btn btn-dark btn-sm flex-fill" @click="deletes('order', val.id)"
                          v-if="!block && (val.payway == 1 || val.payway == 3 || val.payway == 2 || val.payway == 45 || val.payway == 46)">
                          {{ $t("device.orders.button.delete") }}
                        </button>
                        <button class="btn btn-warning btn-sm flex-fill" @click="refund(val.id)"
                          v-if="val.refund_button == 1">
                          {{ $t("device.orders.button.refund") }}
                        </button>
                        <button class="btn btn-secondary btn-sm flex-fill" @click="openOrderv3Settings(val)"
                          v-if="val.orderv3_qr">
                          {{ $t("orders.v3.settings") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                :total="allcount">
              </el-pagination>
            </div>

            <el-dialog :title="$t('orders.v3.create')" :visible.sync="dialogOrderV3QrForm"
              :close-on-click-modal="!orderv3Creating" :close-on-press-escape="!orderv3Creating"
              :show-close="!orderv3Creating">
              <div v-loading="orderv3Creating" :element-loading-text="$t('orders.v3.creating')">
              <el-form ref="form" :model="orderv3form" label-width="80px">
                <el-form-item :label="$t('orders.v3.currency')">
                  <span>{{ globalCurrey }}（{{ currencyLabel() }}）<small class="text-muted ms-1">{{ $t("orders.v3.currencyFromSystem") }}</small></span>
                </el-form-item>
                <el-form-item :label="$t('orders.v3.amount')">
                  <el-input v-model="orderv3form.price"></el-input>
                </el-form-item>
                <el-form-item :label="$t('orders.v3.device')">
                  <el-select v-model="orderv3form.device" multiple filterable
                    :placeholder="$t('global.text.select')" @change="handleOrderv3DeviceChange" style="width: 100%">
                    <el-option value="all" :label="$t('marketing.billing.alldevices')"></el-option>
                    <el-option v-for="item in devicelist" :key="item.ED_id" :label="item.name" :value="item.ED_id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('orders.v3.validTime')">
                  <el-date-picker v-model="orderv3form.time" type="datetimerange" :picker-options="v3formtimeOption"
                    :range-separator="$t('orders.v3.rangeSeparator')" :start-placeholder="$t('orders.v3.startPlaceholder')" :end-placeholder="$t('orders.v3.endPlaceholder')" align="right" style="width: 100%">
                  </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('orders.v3.oneTime')">
                  <el-switch v-model="orderv3form.one_time"
                    :active-text="$t('global.text.yes')" :inactive-text="$t('global.text.no')"></el-switch>
                  <small class="text-muted d-block mt-1">{{ $t("orders.v3.oneTimeTip") }}</small>
                </el-form-item>
                <el-form-item :label="$t('orders.v3.maxVolume')">
                  <el-input-number v-model="orderv3form.max_volume" :min="0" :step="50" :precision="0"
                    controls-position="right" style="width: 100%"></el-input-number>
                  <small class="text-muted d-block mt-1">{{ $t("orders.v3.maxVolumeTip") }}</small>
                </el-form-item>
              </el-form>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogOrderV3QrForm = false" :disabled="orderv3Creating">{{ $t("global.button.cancel") }}</el-button>
                <el-button type="primary" :loading="orderv3Creating" @click="createOrderV3">{{ $t("global.button.submit") }}</el-button>
              </div>
            </el-dialog>

            <el-dialog :title="$t('orders.v3.manageTitle')" :visible.sync="dialogOrderV3Manage" width="920px">
              <el-table v-loading="orderv3QrListLoading" :data="orderv3QrList" size="small" style="width: 100%">
                <el-table-column prop="shid" :label="$t('device.orders.orderid')" min-width="120"></el-table-column>
                <el-table-column prop="code" :label="$t('orders.v3.qrCode')" min-width="140"></el-table-column>
                <el-table-column :label="$t('orders.v3.validTime')" min-width="220">
                  <template slot-scope="scope">
                    {{ formatOrderv3TimeRange(scope.row.begin_time, scope.row.end_time) }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('orders.v3.maxVolume')" min-width="150">
                  <template slot-scope="scope">
                    {{ formatOrderv3VolumeLimit(scope.row) }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('orders.v3.qrStatus')" min-width="100">
                  <template slot-scope="scope">
                    <el-tag size="mini" :type="scope.row.enable === 0 ? 'info' : 'success'">
                      {{ orderv3QrStatusText(scope.row) }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('device.orders.action')" width="100" fixed="right">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="openOrderv3Settings(scope.row)">
                      {{ $t("orders.v3.settings") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-empty v-if="!orderv3QrListLoading && orderv3QrList.length === 0"
                :description="$t('orders.v3.noQrOrders')"></el-empty>
              <div class="text-end mt-3" v-if="orderv3QrTotal > 0">
                <el-pagination
                  @size-change="handleOrderv3QrSizeChange"
                  @current-change="handleOrderv3QrPageChange"
                  :current-page="orderv3QrPage"
                  :page-sizes="[10, 20, 50]"
                  :page-size="orderv3QrPageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="orderv3QrTotal">
                </el-pagination>
              </div>
            </el-dialog>

            <el-dialog :title="$t('orders.v3.settingsTitle')" :visible.sync="dialogOrderV3Setting" width="520px">
              <el-form :model="orderv3SettingForm" label-width="100px">
                <el-form-item :label="$t('orders.v3.qrCode')">
                  <span>{{ orderv3SettingForm.code || "-" }}</span>
                </el-form-item>
                <el-form-item :label="$t('orders.v3.qrStatus')">
                  <el-tag size="small" :type="orderv3SettingForm.enable === 0 ? 'info' : 'success'">
                    {{ orderv3QrStatusText(orderv3SettingForm) }}
                  </el-tag>
                  <small class="text-muted d-block mt-1" v-if="orderv3SettingForm.type === 2">
                    {{ $t("orders.v3.qrStatusReusable") }}
                  </small>
                </el-form-item>
                <el-form-item :label="$t('orders.v3.maxVolume')">
                  <span>{{ formatOrderv3VolumeLimit(orderv3SettingForm) }}</span>
                  <small class="text-muted d-block mt-1">{{ $t("orders.v3.maxVolumeLockedTip") }}</small>
                </el-form-item>
                <el-form-item :label="$t('orders.v3.validTime')">
                  <el-date-picker v-model="orderv3SettingForm.time" type="datetimerange"
                    :picker-options="v3formtimeOption" :range-separator="$t('orders.v3.rangeSeparator')"
                    :start-placeholder="$t('orders.v3.startPlaceholder')"
                    :end-placeholder="$t('orders.v3.endPlaceholder')" align="right" style="width: 100%">
                  </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('orders.v3.resetEnable')">
                  <el-switch v-model="orderv3SettingForm.reset_enable"
                    :active-text="$t('global.text.yes')" :inactive-text="$t('global.text.no')"></el-switch>
                  <small class="text-muted d-block mt-1">{{ $t("orders.v3.resetEnableTip") }}</small>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogOrderV3Setting = false">{{ $t("global.button.cancel") }}</el-button>
                <el-button type="primary" :loading="orderv3SettingSaving" @click="resetOrderv3Qr">
                  {{ $t("orders.v3.resetTime") }}
                </el-button>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
/* 响应式样式 */
.gap-2 {
  gap: 0.5rem;
}

/* 表格响应式优化 */
@media (max-width: 991.98px) {
  .table-responsive {
    border: none;
  }
}

/* 移动端卡片样式优化 */
@media (max-width: 991.98px) {
  .card {
    border: 1px solid #dee2e6;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  }

  .card-body {
    padding: 1rem;
  }

  .btn-group.w-100 .btn {
    font-size: 0.875rem;
  }
}

/* 筛选区域响应式优化 */
@media (max-width: 767.98px) {
  .form-label {
    font-size: 0.875rem;
    font-weight: 600;
    margin-bottom: 0.25rem;
  }

  .el-date-picker,
  .el-select,
  .el-input {
    width: 100% !important;
  }
}

/* 按钮组优化 */
.btn-group .btn {
  margin-right: 0.25rem;
}

.btn-group .btn:last-child {
  margin-right: 0;
}

/* 徽章样式优化 */
.badge {
  font-size: 0.75em;
  padding: 0.25em 0.5em;
}

/* 表格头部样式 */
.table-dark th {
  background-color: #343a40;
  border-color: #454d55;
  font-weight: 600;
}

/* 悬停效果 */
.table-hover tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.075);
}

/* 分页组件响应式 */
@media (max-width: 575.98px) {
  .el-pagination {
    text-align: center;
  }

  .el-pagination .el-pagination__sizes,
  .el-pagination .el-pagination__jump {
    display: none;
  }
}

/* 空状态样式 */
.el-empty {
  padding: 2rem 0;
}

/* 工具提示优化 */
.tooltip {
  font-size: 0.875rem;
}
</style>